<template>
  <div class="partner-category animatedBox">
    <div class="container fluid">
      <div class="card p-1">
        <fd-table
          :componentTitle="'Partner Categories'"
          :routerButton="routerButton"
          :tableButton="actionButton"
          :indexed="true"
          :plugin="{
            search: [1, 2],
          }"
          :searchBarTitle="'Search from title...'"
          :getFunction="getAllPartnerCategories"
        ></fd-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "partner-category",
  data() {
    return {
      routerButton: [
        {
          title: "New Category",
          class: "add",
          routerLink: "/partner-category/add",
        },
      ],
      actionButton: [
        {
          title: "Edit",
          class: "edit",
          routerLink: "/partner-category/edit",
        },
        {
          title: "Delete",
          class: "delete",
          routerLink: null,
          onclick: async (id) => {
            const c = confirm(
              "Are you sure to delete this category? Every partner in this category will also be deleted. You cannot undo after this. Proceed?"
            );

            if (c) {
              return this.removePartnerCategory(id);
            }
          },
          getData: true,
        },
      ],
    };
  },
  methods: {
    async getAllPartnerCategories(keyword, currentPage, perPage, isLoading) {
      const request = await this.$store.dispatch(
        "partnerCategory/getAllPartnerCategory",
        {
          keyword: keyword,
          currentPage: currentPage,
          perPage: perPage,
          isLoading: isLoading,
        }
      );

      return request;
    },
    async removePartnerCategory(id) {
      const request = await this.$store.dispatch(
        "partnerCategory/deletePartnerCategory",
        id
      );

      return request;
    },
  },
};
</script>

<style>
.partner-category {
}
</style>